import { defineBoot } from '#q-app';

export interface AppConfig {
  api: {
    baseUrl: string;
    timeout: number;
  };
  environment: string;
  appName: string;
  appUrl: string;
  debug: boolean;
  oauth: {
    clientId: string;
  };
  upload: {
    maxFileSizeBytes: number;
    maxFileSizeMB: number;
  };
}

// Upload limits - synchronized with server configuration (Terraform, nginx, PHP)
// Server: php_upload_max_filesize=64M, php_post_max_size=64M, client_max_body_size=64M
const MAX_FILE_SIZE_MB = 64;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 64MB in bytes

// Create a type-safe config object from environment variables
const config: AppConfig = {
  api: {
    baseUrl: import.meta.env.VITE_API_URL || '',
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 50000,
  },
  environment: import.meta.env.VITE_APP_ENV || 'local',
  appName: import.meta.env.VITE_APP_NAME || 'Staff Portal',
  appUrl: import.meta.env.VITE_APP_URL || '',
  debug: import.meta.env.VITE_APP_DEBUG === 'true',
  oauth: {
    clientId: import.meta.env.VITE_OAUTH_CLIENT_ID || '',
    // clientSecret removed — the API holds it server-side; never bundle it.
  },
  upload: {
    maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
    maxFileSizeMB: MAX_FILE_SIZE_MB,
  },
};

export default defineBoot(({ app }) => {
  // Make config available globally
  app.config.globalProperties.$config = config;
  app.provide('config', config);
});

// Export the config for direct imports
export { config };
